/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useEffect, useRef } from 'react'
import { useGLTF } from '@react-three/drei'

import { useFrame, useThree} from '@react-three/fiber'
import * as THREE from 'three'
// import THREEx from 'three-noise-shader-material'

// var THREE = require('three')
var NoiseShaderMaterial = require('three-noise-shader-material')(THREE)


var fragmentShader	= [
	NoiseShaderMaterial.noiseFragmentShader,
	'',
	'',

	'uniform float time;',
	'varying vec2 vUv;',
	'',
'	float surface3( vec3 coord ){',
'		float height	= 0.0;',
'		height	+= abs(snoise(coord      )) * 1.0;',
'		height	+= abs(snoise(coord * 2.0)) * 0.5;',
'		height	+= abs(snoise(coord * 4.0)) * 0.25;',
'		height	+= abs(snoise(coord * 8.0)) * 0.125;',
'		return height;',
'	}',
'',
'	void main( void ) {',
'		float heightB	= surface3( vec3( vUv, time + 1.0 ));',
'		float heightG	= surface3( vec3( vUv, time )  ) - 0.4;',
'		float heightR	= surface3( vec3( vUv, time) ) -0.4;',
// '		float heightR	= heightB / 1.8;',
// '		float heightG	= heightB / 1.8;',

'		gl_FragColor	= vec4( vec3(heightR, heightG, heightB), 1.0 );',
'	}',
].join('\n')

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/cotton_candy.glb')

  // const {scene, render} = useThree();

  // var material	= new NoiseShaderMaterial({
	// 	fragmentShader	: fragmentShader
  // })

  useEffect(() => {
    // material.uniforms[ "scale" ].value = new THREE.Vector2( 60, 60 );
  })
  // const loader = new THREE.TextureLoader();
  // const texture = new THREE.TextureLoader().load( "/noise.png" );
  // texture.wrapS = THREE.RepeatWrapping;
  // texture.wrapT = THREE.RepeatWrapping;
  // texture.flipY = false;
  // texture.magFilter = THREE.NearestFilter;
  // texture.repeat.set( 10, 10 );

  useFrame((state, delta) => {
    // if (material.uniforms === undefined) {
    //   console.log("material " + material);
    //   return;
    // }
    // lastTimeMsec	= lastTimeMsec || nowMsec-1000/60
		// var deltaMsec	= Math.min(200, nowMsec - lastTimeMsec)
		// lastTimeMsec	= nowMsec
    // material.uniforms[ "time" ].value	+= delta  ;
    
  })

   
  return (
    <group ref={group} {...props}>
      <mesh
        // material={materials['Default OBJ']}
        // material={material}
        // geometry={geometry}
        geometry={nodes['15192_Cotton_Candy_v1'].geometry}
        position={[1.55, -0.71, -0.04]}
        rotation={[0.93, -0.46, -1.91]}
        scale={[0.5, 0.5, 0.5]}
        layers={0}>
      <meshStandardMaterial color={'white'} roughness={'0.8'} />
      </mesh>
    </group>
  )
}

useGLTF.preload('/cotton_candy.glb')
